import { TFunction } from "i18next";
import { IOptions } from "../../Admin";

export default function tournamentOptions(t: TFunction<"translation", undefined>, tournamentId: number): IOptions[] {
  if (isNaN(tournamentId)) {
    return [];
  } else {
    return [
      {
        label: t("secure.facility.tournament.tournament_menu.001"),
        url: `/admin/tournament/${tournamentId}/home`,
      },
      {
        label: t("secure.facility.tournament.tournament_menu.011"),
        url: `/admin/tournament/${tournamentId}/players`,
      },
      {
        label: t("secure.facility.tournament.tournament_menu.005"),
        url: process.env.REACT_APP_SCORING_URL,
        urlNewTab: true,
      },

      {
        label: t("secure.facility.tournament.tournament_menu.007"),
        url: `/admin/tournament/${tournamentId}/tournament-settings`,
        subOptions: [
          {
            label: t("secure.facility.tournament.tournament_menu.008"),
            url: `/admin/tournament/${tournamentId}/tournament-settings/general`,
          },
          {
            label: t("secure.facility.tournament.tournament_menu.015"),
            url: `/admin/tournament/${tournamentId}/tournament-settings/registration`,
          },
          {
            label: t("secure.facility.tournament.tournament_menu.010"),
            url: `/admin/tournament/${tournamentId}/tournament-settings/organizers`,
          },
          {
            label: t("secure.facility.tournament.tournament_menu.016"),
            url: `/admin/tournament/${tournamentId}/prizeAccounts`,
          },
        ],
      },
    ];
  }
}
